import { apiClient } from './api';
import type { Metric, CurrentMetrics } from '../types/metrics';

export const metricsService = {
  getHistory: async (
    serverId?: string,
    tenantId?: string,
    startDate?: Date,
    endDate?: Date,
    limit?: number
  ): Promise<Metric[]> => {
    const params = new URLSearchParams();
    if (serverId) params.append('serverId', serverId);
    if (tenantId) params.append('tenantId', tenantId);
    if (startDate) params.append('startDate', startDate.toISOString());
    if (endDate) params.append('endDate', endDate.toISOString());
    if (limit) params.append('limit', limit.toString());

    const response = await apiClient.get<Metric[]>(
      `/Metrics/history${params.toString() ? `?${params.toString()}` : ''}`
    );
    return response.data;
  },

  getCurrentMetrics: async (serverId: string): Promise<CurrentMetrics | null> => {
    try {
      const response = await apiClient.get<CurrentMetrics>(`/Metrics/current/${serverId}`);
      return response.data;
    } catch (error: any) {
      if (error.response?.status === 404) {
        return null;
      }
      throw error;
    }
  },
};










